import { ApiParameter, post } from "@insite/client-framework/Services/ApiService";

export interface ExistingUserAssignModel extends ApiParameter {
    email: string;
}

const customApiUrl = "/api/v2/UserProfileWebsiteAssign/WebsiteAssign";

export function assignExistingUser(parameter: ExistingUserAssignModel) {
    return post<ExistingUserAssignModel>(`${customApiUrl}`, parameter);
}
